import React from "react";

import Modal from "./Modal";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";

const Loader = () => (
  <>
    <div className="header">
      <img
        src={BACKGROUND_WALLET.SOURCE}
        alt="background"
        className="background-wallet"
      />
      <h4 className="mb-2">Wallet connected!</h4>
    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      <p className="py-2">Approving your request..</p>
      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick, event }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-3">Sell GangstaBet</h4>
      <p className="text">
        You successfully granted permission to <strong>{event.toUpperCase()}</strong>.
      </p>
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button
        className="btn btn-outline-primary profile"
        onClick={() => onClick("success")}
      >
        Continue
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Failed</h4>
      <p className="text my-3">
        Could not approve due to transaction failure, please try again after sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const ApprovalModalLoader = ({ response, onClick, isVisible, event }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {response.status === "success" ? (
        <Success onClick={onClick} event={event} />
      ) : response.status === "cancel" ? (
        <Cancel onClick={onClick} />
      ) : response.status === "error" ? (
        <Error onClick={onClick} />
      ) : (
        <Loader />
      )}
    </Modal>
  );
};

export default ApprovalModalLoader;
